module.exports = __webpack_public_path__ + "img/稀蜴大学.336ee00f.png";